import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import {TopButtonPointAction, TopButtonPointEdit, TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../../utilities/TabUtilities";

export default class PrzystankiTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointAction titleContent={'Pokaż na mapie'} onClick={()=>{ this.props.pokazNaMapie(row)}} buttonIcon={'fa fa-globe'} disabled={!(Boolean(row.szGps) &&Boolean(row.dlGps))}/>
                {
                    (row.domyslny === 1) ?
                        <TopButtonPointAction onClick={() => {
                            this.props.handleZmienNaDomyslny(row, 0)
                        }} buttonIcon={'fa fa-flag-o'} titleContent={'Usuń z domyślnych'}/>
                        :
                        <TopButtonPointAction onClick={() => {
                            this.props.handleZmienNaDomyslny(row, 1)
                        }} buttonIcon={'fa fa-flag'} titleContent={'Zaznacz jako przystanek domyślny'}/>
                }
                <TopButtonPointEdit onClick={() => {
                    this.props.handleEdytuj(row)
                }} titleContent={'Edytuj przystanek'}/>
                <TopButtonPointRemove onClick={() => {
                    this.props.handleUsun(row)
                }} titleContent={'Usuń przystanek'}/>
            </div>
        )
    }

    formatDomyslny(cell, row) {
        if (Boolean(cell) && cell !== 0) {
            return <div title={'Przystanek domyślny'} style={{color: '#132239', fontSize: '20px', textAlign: 'center', lineHeight: '30px'}}><i
                className={'fa fa-flag'}></i></div>
        }
    }

    formatOstatniaAktualizacja(cell,row){
        if(Boolean(cell)){
            return cell.replace('T',' ').substr(0,16)
        }
    }

    render() {

        let domyslne = {
            1: 'tak',
            0: 'nie'
        }

        const options = {
            sizePerPage: 15,
            sizePerPageList: [10, 15, 30],
            sortName: 'nazMi',
            sortOrder: 'asc',
            noDataText: 'Brak pasujących rekordów'
        };
        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover

                >
                    <TableHeaderColumn dataField='idPr' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazMi' dataSort
                                       thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Nazwa miejscowości</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazPr' dataSort
                                       thStyle={tabgrid.tg6} tdStyle={tabgrid.tg6}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Nazwa przystanku</TableHeaderColumn>
                    <TableHeaderColumn dataField='szGps' dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Szerokość geo.</TableHeaderColumn>
                    <TableHeaderColumn dataField='dlGps' dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Długość geo.</TableHeaderColumn>
                    <TableHeaderColumn dataField='gpsDataAktualizacji' dataSort
                                       dataFormat={this.formatOstatniaAktualizacja}
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Ostatnia aktualizacja</TableHeaderColumn>
                    <TableHeaderColumn dataField='domyslny' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={{type: 'SelectFilter', options: domyslne, selectText: 'Wybierz'}}
                                       formatExtraData={domyslne}
                                       dataFormat={this.formatDomyslny}
                    >Domyślny?</TableHeaderColumn>
                    <TableHeaderColumn dataField='idPr'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunPlusDodatkowaHtml('Pokaż | Flaga')}</TableHeaderColumn>

                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/przystanki/components/PrzystankiTable.js